// Requisiti della password, uguali per tutte le app (il controllo vero lo fa il backend: App\Services\PasswordPolicy,
// con le stesse regole). L'ordine è quello mostrato all'utente.
export const PASSWORD_RULES = [
  { key: 'length', test: (p) => p.length >= 8 },
  { key: 'upper', test: (p) => /[A-Z]/.test(p) },
  { key: 'lower', test: (p) => /[a-z]/.test(p) },
  { key: 'special', test: (p) => /[^A-Za-z0-9]/.test(p) },
  { key: 'number', test: (p) => /[0-9]/.test(p) },
];

export const isPasswordValid = (password) => PASSWORD_RULES.every((rule) => rule.test(password || ''));
